import script from "./MailFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./MailFooter.vue?vue&type=script&setup=true&lang=js"

import "./MailFooter.vue?vue&type=style&index=0&id=394b0f88&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-394b0f88"]])

export default __exports__